import React, { useEffect } from 'react'
import { useEntitiesByIds } from 'hamster-react';

import { GeoItem } from 'cityads-v3/types/geos';

type RegionsProps = {
  ids: number[]
  onUpdate?: () => void
}

export default function Regions({ ids, onUpdate }: RegionsProps) {
  const [isWaiting, error, regions] = useEntitiesByIds('geo', ids) as [boolean, boolean, GeoItem[]]

  const result = (isWaiting || error)
    ? ''
    : regions.map(region => region?.name).filter(name => !!name).join(', ')

  useEffect(() => {
    if (onUpdate) {
      onUpdate()
    }
  }, [result, onUpdate])

  return <>{result}</>;
}
